var BASWebServices;
(function (BASWebServices) {
    var HintService = (function () {
        function HintService($http) {
            this.$http = $http;
            this.hintList = [];
            this.fillHintListWithHintsFromServer(BASWebServices.ConfigService.GET_HINT_URL());
        }
        HintService.Factory = function ($http) {
            return new HintService($http);
        };
        HintService.prototype.setRandomEntryToScope = function () {
            var randNum = Math.floor(Math.random() * this.hintList.length);
            return this.hintList[randNum];
        };
        HintService.prototype.fillHintListWithHintsFromServer = function (path) {
            this.hintList = new Array();
            this.$http.get(path, {
                _this: this,
                path: path
            })
                .then(function (response) {
                var data = response.data;
                var status = response.status;
                var headers = response.headers;
                var config = response.config;
                var content = data;
                var contentSplit = content.split("\n");
                content = "";
                for (var i = 0; i < contentSplit.length; i++) {
                    if (contentSplit[i].indexOf("#") == 0 || contentSplit[i] == "")
                        continue;
                    else
                        content += contentSplit[i] + "\n";
                }
                var dataSplit = content.split("----------\n");
                var hintList = [];
                for (var i = 1; i < dataSplit.length; i++) {
                    var currBlock = dataSplit[i];
                    var hint = currBlock.replace("H: ", "");
                    if (hint != "") {
                        hintList.push(hint);
                    }
                }
                config._this.hintList = hintList;
            })
                .catch(function (response) {
                var config = response.config;
                config._this.$scope.WEBSERVICE_VERSION = " N/A ";
                console.error("Could not retrieve WebMAUS version from url " + path);
            });
        };
        return HintService;
    }());
    BASWebServices.HintService = HintService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=HintService.js.map